import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, unref as _unref, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "p-3" }
const _hoisted_2 = { class: "v-col-6 v-col-md-3" }
const _hoisted_3 = { class: "v-col-6 v-col-md-3 ms-2" }
const _hoisted_4 = { class: "p-2" }
const _hoisted_5 = {
  key: 0,
  class: "p-2"
}
const _hoisted_6 = {
  key: 1,
  class: "p-2"
}

import Api from '@/services/api'
    import { onBeforeMount } from 'vue'
    import { ref } from 'vue';
    import { ElButton, ElIcon, ElInput, ElMessage, ElMessageBox, ElRow } from 'element-plus';
    import { useStore } from 'vuex';
    import PaginatedTable from '@/components/PaginatedTable.vue';
    import { Paginated } from '@/services/types/paginated';
    import { defaultPaginated } from '@/utilities/helpers';
    import { Store } from '@/services/types/store';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'StoresView',
  setup(__props) {

    const loading = ref<boolean>(true)
    const data = ref<Paginated<Store>>(defaultPaginated)
    const q = ref<string>('')
    const status = ref<'approved' | 'blocked'| 'all'>('all')
    const states = ref<{value: string, label: string}[]>([
        {value: 'approved', label: 'Aprovadas'},
        {value: 'blocked', label: 'Nao aprovadas'},
        {value: 'all', label: 'Todas'},
    ])
    const searchType = ref<'string' | 'number'>('string')
    const cod = ref<number>()

    const getStores = async (q = '', page = 1) => {
        console.log("Okay")
        loading.value = true
        const res = await Api.get(`admin/stores?q=${q}&page=${page}&status=${status.value}`)
        if (res.status == 200) {
            data.value = res.data.stores
            console.log(res.data.stores)
        } else {
            ElMessageBox.alert('Ocorreu um erro ao buscar os dados')
        }
        loading.value = false
    }
    
    const getStore = async (id: number | undefined) => {
        if (!id || id <= 0) {
            getStores()
        } else {
            loading.value = true
            data.value.last_page = 1
            data.value.current_page = 1
            const res = await Api.get('admin/stores/' + id)
            if (res.status == 200) {
                data.value.data = [res.data.store]
            } else {
                ElMessageBox.alert('Não foi encontrado nenhuma loja com este código')
                data.value.data = []
            }
            loading.value = false
        }
    }

    const changePage = (page: number) => {
        getStores(q.value, page)
    }

    onBeforeMount(() => {
        getStores()
    })

    const vuex = useStore()
    vuex.watch((state, getter) => getter.openModal, async (val, oldVal) => {
        if (oldVal == 2) {
            // new product
            await getStores()
        }
    })

    const approve = async (row: any) => {
        row.loading = true
        const res = await Api.post(`admin/stores/${row.id}`, {})
        if (res.status != 200) {
            ElMessage.error({message: 'Ocorreu um erro ' + res.data.message ? res.data.message:''})
        } else {
            ElMessage.success({message: row.name + ' Actualizado com sucesso'})
            row.approved_at = res.data.store.approved_at
        }
        row.loading = false
    }

    const disapprove = async (row: any) => {
        row.loading = true
        const res = await Api.delete(`admin/stores/${row.id}`)
        if (res.status != 200) {
            ElMessage.error({message: 'Ocorreu um erro ' + res.data.message ? res.data.message:''})
        } else {
            ElMessage.success({message: row.name + ' Actualizado com sucesso'})
            row.approved_at = res.data.store.approved_at
        }
        row.loading = false
    }

return (_ctx: any,_cache: any) => {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Search = _resolveComponent("Search")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, { header: "Lojas cadastradas" }, {
      default: _withCtx(() => [
        _createVNode(_unref(ElRow), { class: "py-2" }, {
          default: _withCtx(() => [
            _cache[8] || (_cache[8] = _createElementVNode("h5", { class: "v-col-6 v-col-md-9 me-3" }, "Pesquisar", -1)),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_el_radio_group, {
                modelValue: searchType.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchType).value = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio, {
                    value: "string",
                    border: ""
                  }, {
                    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                      _createTextVNode("por nome", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio, {
                    value: "number",
                    border: ""
                  }, {
                    default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                      _createTextVNode("Pelo codigo", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_select, {
                modelValue: status.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((status).value = $event)),
                placeholder: "Estados",
                style: {"width":"240px"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(states.value, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _: 1
        }),
        (searchType.value == 'string')
          ? (_openBlock(), _createBlock(_unref(ElRow), {
              key: 0,
              class: "pb-5"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElInput), {
                  type: "search",
                  name: "q",
                  style: {"flex":"1"},
                  modelValue: q.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((q).value = $event)),
                  class: "mx-1",
                  placeholder: "Procurar produtos"
                }, null, 8, ["modelValue"]),
                _createVNode(_unref(ElButton), {
                  loading: loading.value,
                  onClick: _cache[3] || (_cache[3] = () => getStores(q.value))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElIcon), null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Search)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_unref(ElRow), {
              key: 1,
              class: "pb-5"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElInput), {
                  type: "number",
                  name: "cod",
                  modelValue: cod.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((cod).value = $event)),
                  style: {"flex":"1"},
                  class: "mx-1",
                  placeholder: "Digite o codigo do produto"
                }, null, 8, ["modelValue"]),
                _createVNode(_unref(ElButton), {
                  disabled: cod.value ? false:true,
                  loading: loading.value,
                  onClick: _cache[5] || (_cache[5] = () => getStore(cod.value))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElIcon), null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Search)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["disabled", "loading"])
              ]),
              _: 1
            })),
        _createVNode(PaginatedTable, {
          loading: loading.value,
          page: data.value.current_page,
          "show-rows": 10,
          pages: data.value.last_page,
          data: data.value.data.filter((store) => store.id != 1),
          cols: [
                {label: 'Cod', prop: 'id'},
                {label: 'Nome', prop: 'name'},
                {label: 'Localização', prop: 'location'},
                {label: 'Contacto', prop: 'phone'},
                {label: 'Email', prop: 'email'},
                {label: 'Tipo de produto', prop: 'category'},
            ],
          onChange: changePage
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "Dono da loja",
              "class-name": "auto",
              "min-width": 150
            }, {
              default: _withCtx((data) => [
                _createTextVNode(_toDisplayString(data.row.user?.name) + " (" + _toDisplayString(data.row.user?.phone) + ") ", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Acções",
              "class-name": "auto",
              "min-width": 150
            }, {
              default: _withCtx((data) => [
                _createElementVNode("span", _hoisted_4, [
                  _createVNode(_unref(ElButton), {
                    type: "primary",
                    tag: "router-link",
                    to: '/stores/' + data.row.id,
                    icon: "View",
                    title: "Ver mais"
                  }, null, 8, ["to"])
                ]),
                (!data.row.approved_at)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                      _createVNode(_unref(ElButton), {
                        loading: data.row.loading,
                        onClick: () => approve(data.row),
                        type: "warning",
                        icon: "RemoveFilled",
                        title: "Desativar"
                      }, null, 8, ["loading", "onClick"])
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_6, [
                      _createVNode(_unref(ElButton), {
                        loading: data.row.loading,
                        onClick: () => disapprove(data.row),
                        type: "success",
                        title: "Activavar",
                        icon: "Select"
                      }, null, 8, ["loading", "onClick"])
                    ]))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["loading", "page", "pages", "data"])
      ]),
      _: 1
    })
  ]))
}
}

})